module.exports = __webpack_public_path__ + "img/1@2x.0fd7de67.png";